import Vue from 'vue';
import Router from 'vue-router';
import routes from './router'
import NProgress from 'nprogress'
// import $fn from '@/utils/fn';
// import PageApi from '@/apis/pageApi'
import cookies from "@/utils/cookie";
import {
    getUserInfo,
} from '@/req/user'

Vue.use(Router);

const router = new Router({
    mode: 'hash',
    base: process.env.publicPath,
    routes,
});

router.afterEach((to, from) => {
    // NProgress.done();
    window.scrollTo(0, 0)
})

router.beforeEach(async (to, from, next) => {
    // NProgress.start();
    /* 路由发生变化修改页面title */
    if (to.meta && to.meta.title) {
        if (to.meta.title == "提现" && to.query.type == '2') {
            document.title = '交易行'
        } else {
            document.title = to.meta.title;
        }
    }
    // 权限控制
    const jyhInfo = sessionStorage.getItem("h5jyhInfo");
    // if (!jyhInfo && !to.query.userinfo || process.env.NODE_ENV === "development") {
    if (true || process.env.NODE_ENV === "development") {
        if (to.meta && to.meta.auth && to.meta.auth.length > 0) {
            // tslint:disable-next-line:prefer-const
            for (let auth of to.meta.auth) {
                // 登录权限校验
                if (auth === 1) {
                    try {
                        // if (!cookies.getToken()) {
                        //     next("/login")
                        // }
                        if (cookies.getToken()) {
                            const res = await getUserInfo()
                            if (res.code == 200) {
                                await window.App.$store.dispatch('user/authInfo', res.data.userinfo)
                            }
                            //  else if (res.code == 400) {
                            //     cookies.removeToken()
                            // }
                        } else {
                            // next("/login")
                        }
                        // }
                        // if (!user.state.info) {
                        // const obj = {
                        //     token: cookies.getToken()
                        // }
                        // const res = await getUserInfo(obj)
                        // if (res.code == 200) {
                        //     await window.App.$store.dispatch('user/authInfo', res.data.userinfo)
                        // }
                        //        else { window.App.$Message.error(res.msg)
                        //         next("/login")
                        //     }
                        // }
                    } catch (err) {
                        // return next("/login")
                    }
                }
            }
        }
    }

    next();
    /* must call `next` */
})

export default router;
